import React from "react";

import classNames from "classnames";
import isEmpty from "lodash.isempty";
import Link from "next/link";
import styled from "styled-components";

import { useStores } from "../../../contexts/StoreContext";
import useDevice from "../../../shared/customHooks/useDevice";
import ModeToggle from "../ModeToggle";
import SocialMediaLinks from "../SocialMediaLinks";
import MultiColumn from "./MultiColumn";
import MultiColumnAdditionalNavigation from "./MultiColumnAdditionalNavigation";
import MultiColumnContactInfo from "./MultiColumnContactInfo";

const StyledFooter = styled.footer`
  background-color: ${({ theme, $backgroundColour }) =>
    $backgroundColour || theme.footerBackgroundColor};
  color: ${({ theme }) => theme.negativeTextColor};

  a {
    text-decoration: none;
    color: ${({ $linkColor }) => `${$linkColor || "inherit"}`};

    &:hover {
      text-decoration: underline;
    }
  }
`;

function MultiColumnFooter(props) {
  const { navigationStore, footerStore } = useStores();

  const {
    footerLinks,
    additionalFooterNavigation,
    isAdditionalFooterNavigationUsed,
  } = navigationStore;

  const { externalClasses, iconColor, linkColor, footerText } = footerStore;

  const { isMobile } = useDevice();

  const isExternalClassedAdded = !isEmpty(externalClasses);

  const navigationColumnsClassName = classNames({
    "col-12 col-md-4": !isExternalClassedAdded,
    "d-flex": isExternalClassedAdded,
    [externalClasses]: isExternalClassedAdded,
    "flex-column-reverse align-items-center": isMobile,
  });

  const listClassName = classNames({
    "mb-3 mx-4 text-center": isMobile,
    "mb-5": !isMobile,
  });

  const contactSectionClassName = classNames("ms-auto col-lg-4 col-xl-3", {
    "mb-0": !isAdditionalFooterNavigationUsed,
  });
  const contactInfoClassName = classNames("d-flex flex-column", {
    "align-items-end": !isMobile,
    "align-items-start ps-5": isMobile,
  });

  const rowClassName = classNames("row", { "flex-column-reverse": isMobile });

  return (
    <StyledFooter
      $linkColor={linkColor}
      $backgroundColour={props?.backgroundColour}
    >
      <div className="container-xxl py-4">
        <div className={rowClassName}>
          {!isEmpty(footerLinks) && (
            <div className={navigationColumnsClassName}>
              <MultiColumn
                listClassName={listClassName}
                navigationLinks={footerLinks}
              />
              {isMobile && (
                <div className="d-flex justify-content-start pt-4 ps-5">
                  <p className="text-start">
                    <SocialMediaLinks iconColor={iconColor} />
                    <div>
                      <span className="me-5">
                        Site by{" "}
                        <a href="https://talent-funnel.com">Talent Funnel</a>
                      </span>
                      <Link href="/sitemap">Sitemap</Link>
                    </div>
                  </p>
                </div>
              )}
            </div>
          )}
          <div className={contactSectionClassName}>
            <div className={contactInfoClassName}>
              <h5 className="mb-4">{footerText}</h5>

              <div className="mb-4">
                <MultiColumnContactInfo />
              </div>
              {!isMobile && <SocialMediaLinks iconColor={iconColor} />}
            </div>
          </div>
        </div>
        <ModeToggle />
      </div>
      {isAdditionalFooterNavigationUsed && (
        <MultiColumnAdditionalNavigation
          additionalFooterNavigation={additionalFooterNavigation}
        />
      )}
    </StyledFooter>
  );
}

export default MultiColumnFooter;
